/**
 * Returns the per-request CSP nonce that the Express server stamped into the
 * served HTML. Vite's `html.cspNonce` option emits a
 * `<meta property="csp-nonce" nonce="<nonce>">` tag; the server replaces the
 * `__CSP_NONCE__` placeholder with the real nonce before delivering the page.
 *
 * Use this when creating `<style>` or `<script>` elements programmatically so
 * the browser can allow them via the nonce instead of relying on `'unsafe-inline'`.
 */
export function getCspNonce(): string | undefined {
  const meta = document.querySelector('meta[property="csp-nonce"]');
  if (meta && meta instanceof HTMLMetaElement && meta.nonce) {
    return meta.nonce;
  }
}
